// extracted by mini-css-extract-plugin
export default {"container":"rq-z","brandName":"sq-z","productName":"tq-z","productNamePdpEnhancements":"uq-z","breakLongProductName":"vq-z"};